import { Component, Input } from '@angular/core';
import { FormControl } from '@angular/forms';

@Component({
  selector: 'app-date-picker',
  templateUrl: './date-picker.component.html',
  styleUrls: ['./date-picker.component.scss']
})
export class DatePickerComponent {
  @Input() control!: FormControl;
  @Input() submitted: boolean = false;
  @Input() type: string = "";
  @Input() placeholder: string = "";
  @Input() errorMessage: string = "";
  @Input() invalidMessage: string = "Invalid date";
  @Input() min: string | null = null;
  @Input() max: string | null = null;
  @Input() disableInvalidCheck: boolean = false;

  onInput(event: any): void {
    if (!this.control) {
      return;
    }
    if (this.disableInvalidCheck) {
      return;
    }
    const target = event?.target as HTMLInputElement;
    const hasBadInput = !!target?.validity?.badInput;
    const value = target?.value;
    const hasValidationMessage = !!target?.validationMessage;
    const isValueMissing = !!target?.validity?.valueMissing;

    if (hasBadInput) {
      const mergedErrors = { ...(this.control.errors || {}) };
      mergedErrors['invalidDate'] = true;
      delete mergedErrors['required'];
      this.control.setErrors(mergedErrors);
      return;
    }

    if (!value && hasValidationMessage && !isValueMissing) {
      const mergedErrors = { ...(this.control.errors || {}) };
      mergedErrors['invalidDate'] = true;
      delete mergedErrors['required'];
      this.control.setErrors(mergedErrors);
      return;
    }

    if (value && !this.isValidDateValue(value)) {
      const mergedErrors = { ...(this.control.errors || {}) };
      mergedErrors['invalidDate'] = true;
      delete mergedErrors['required'];
      this.control.setErrors(mergedErrors);
      return;
    }

    // Clear invalidDate when user fixes input
    if (this.control.errors?.['invalidDate']) {
      const mergedErrors = { ...(this.control.errors || {}) };
      delete mergedErrors['invalidDate'];
      this.control.setErrors(Object.keys(mergedErrors).length ? mergedErrors : null);
    }

    // Preserve required logic elsewhere; no change if value empty and no bad input
    if (!value && this.control.errors?.['required']) {
      this.control.updateValueAndValidity({ emitEvent: false });
    }
  }

  private isValidDateValue(raw: string): boolean {
    const trimmed = raw.trim();
    if (!trimmed) {
      return false;
    }

    const match = /^(\d{4})-(\d{2})-(\d{2})$/.exec(trimmed);
    if (!match) {
      return false;
    }
    const year = Number(match[1]);
    const month = Number(match[2]);
    const day = Number(match[3]);
    const constructed = new Date(year, month - 1, day);
    return !isNaN(constructed.getTime()) &&
      constructed.getFullYear() === year &&
      constructed.getMonth() === month - 1 &&
      constructed.getDate() === day;
  }
}
